import {
  createContext,
  useContext,
  useEffect,
  useReducer,
  useRef,
} from "react";
import { useGetUserPointHistory } from "../../../../api/UdianPointHistory";
import {
  initialState,
  setLoading,
  setIntegralList,
  setTotal,
  reducer,
  setQuery
} from "./reducer";
import { mediaMatch } from "../../../../utils";
import cookies from "../../../../utils/cookies";

const Context = createContext(initialState);

function MyIntegralController() {
  const { state, dispatch } = useMyIntegralContext();
  const { getPointHistory, loading } = useGetUserPointHistory();
  const queryCache = useRef(state.query);
  const isMdmax = mediaMatch.isMdmax;

  useEffect(() => {
    dispatch(setLoading(loading));
  }, [loading]);

  const getPointHistoryList = async (query) => {
    let q = { ...queryCache.current, ...query };
    let { data } = await getPointHistory(q);

    dispatch(setQuery(q));
    queryCache.current = q;
    if (isMdmax) {
      let list = data.records;
      //   listCache.current = list;
      dispatch(setIntegralList(list));
    } else {
      dispatch(setIntegralList(data.records));
    }
    dispatch(setTotal(Number(data.total)));
  };

  return {
    getPointHistoryList,
  };
}

function useMyIntegralContext() {
  const { state, dispatch } = useContext(Context);

  return {
    state,
    dispatch,
  };
}

export { useMyIntegralContext, MyIntegralController };

export default function MyIntegralContext({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <Context.Provider value={{ state, dispatch }} reducer={reducer}>
      {children}
    </Context.Provider>
  );
}
